import React from 'react';
import { CheckBox } from '@sky-distribution/react-commons-ui';
import { CheckBoxProps } from '@sky-distribution/react-commons-ui/lib/CheckBox/CheckBox.types';
import { useTypedTranslate } from '../../translations/useTypedTranslate';
import { useConfigValuesContext } from '../../common/contexts/ConfigValues/useConfigValuesContext';
import { StyledLinkedText } from '../Common';
import { TENANT_NAME } from '../../config/tenants';

export const ConsentsCheckBox: React.FC<Omit<CheckBoxProps, 'text'>> = (props) => {
  const { t } = useTypedTranslate();
  const { configValues } = useConfigValuesContext();

  return (
    <CheckBox
      {...props}
      text={
        <div>
          {t('CONSENT_TO_CONTACT_AND_READ_INFO')}{' '}
          <StyledLinkedText href={configValues[TENANT_NAME].clause} target="_blank" rel="noopener">
            {t('INFORMATION_REGARDING_DATA_PROCESSING')}
          </StyledLinkedText>
        </div>
      }
    />
  );
};
